import React, { Fragment } from 'react';

import { Cart } from '../components/cart';
import { AuthWall } from '../components/auth-wall';

import { PageLayout } from '../components/page-layout';
import { initializeApollo } from '../lib/auth/apollo';
import { getNav } from '../lib/get-nav';

export async function getStaticProps() {
  const apolloClient = initializeApollo();

  await getNav(apolloClient);

  return {
    props: {
      initialApolloState: apolloClient.cache.extract(),
    },
    revalidate: 100,
  };
}

const CartPage = () => {
  return (
    <Fragment>
      <AuthWall>
        <PageLayout backgroundColor="scheme.bgSecondary">
          <Cart />
        </PageLayout>
      </AuthWall>
    </Fragment>
  );
};

export default CartPage;
